import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getUser, getUserEntity } from "../redux/features/auth/authService";
import { selectUserDetails, selectUserEntityDetails } from "../redux/features/auth/authSlice";
import GridLoader from "react-spinners/GridLoader";

const PrivateRoute = ({ children, allowedRoles, roleRedirects }) => {
  const { roleName, isLoggedIn, isUserDetailsLoading, hasCheckedAuth } = useSelector(selectUserDetails);
  const { user_certificate_entity } = useSelector(selectUserEntityDetails);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!hasCheckedAuth) {
      dispatch(getUser());
    }
  }, [dispatch, hasCheckedAuth]);

  useEffect(() => {
    if (!hasCheckedAuth) {
      dispatch(getUserEntity());
    }
  }, [dispatch, hasCheckedAuth]);

  if (isUserDetailsLoading || !hasCheckedAuth) {
    return <div className={`loader-style`}>
      <GridLoader color="#df771c" />
    </div>;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!allowedRoles.includes(roleName)) {
    return <Navigate to={roleRedirects[roleName] || "/login"} replace />;
  }

  return children;
};

export default PrivateRoute;
